export const CONVERSATION_ACTION_TYPES = [
  'payment',
  'visit',
  'waitlist',
  'survey',
  'file',
  'review',
  'listing',
  'profile'
] as const;

export type ConversationActionType = (typeof CONVERSATION_ACTION_TYPES)[number];

export const CONVERSATION_ACTION_LABELS: Record<
  ConversationActionType,
  string
> = {
  payment: 'Request Payment',
  visit: 'Book Visit',
  waitlist: 'Add to Waitlist',
  survey: 'Send Puppy Application',
  file: 'Share File',
  review: 'Request Review',
  listing: 'Share Listing',
  profile: 'Share Profile'
};

export const CONVERSATION_ACTION_FLAGS: Record<ConversationActionType, string> =
  {
    payment: 'conversation_actions.request_payment',
    visit: 'conversation_actions.book_visit',
    waitlist: 'conversation_actions.add_to_waitlist',
    survey: 'conversation_actions.send_survey',
    file: 'conversation_actions.share_file',
    review: 'conversation_actions.request_review',
    listing: 'conversation_actions.share_listing',
    profile: 'conversation_actions.share_profile'
  };

export const CONVERSATION_CARD_ACTION_TYPES: readonly ConversationActionType[] =
  CONVERSATION_ACTION_TYPES;

export const isConversationActionType = (
  value: string
): value is ConversationActionType =>
  (CONVERSATION_ACTION_TYPES as readonly string[]).includes(value);

export const isCardConversationActionType = (
  value: string
): value is ConversationActionType =>
  (CONVERSATION_CARD_ACTION_TYPES as readonly string[]).includes(value);

export const conversationActionLabel = (value: string): string =>
  isConversationActionType(value) ? CONVERSATION_ACTION_LABELS[value] : value;
